import React from "react";
import './css/Iframe.css';

const Iframe = ({ source, start, height = '60%' }) => {
        if (!source) {
            return <div>Loading...</div>;
        }

        const src = source; 
        return (
            <div className="emdedResponsive">
                <iframe 
                    src={src + "?showinfo=0&start=" + String(start) + "&end=" + "&modestbranding=1&rel=0;"}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title='embedded youtube'
                    className="iframe"
                    height={height}
                >
                    
                </iframe>
            </div>
        );
};

export default Iframe;